import { render, staticRenderFns } from "./InformeComunicaciones.vue?vue&type=template&id=fb5a1c34&"
import script from "./InformeComunicaciones.vue?vue&type=script&lang=js&"
export * from "./InformeComunicaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports